import Config from "../_config/config";
import myAxios from "./axiositeachWrapper";

const BASE = `${Config.nodeSiteUrl}v1/student-photo-upload`;

export type PreviewStatus = "matched" | "not-found" | "invalid-type" | "duplicate-code";
export type CommitStatus = "uploaded" | "skipped" | "failed";

export interface PreviewEntry {
  fileName: string;
  studentCode: string;
  status: PreviewStatus;
  enquiryId: number | null;
  studentName: string | null;
  message: string | null;
}

export interface PreviewSummary {
  total: number;
  matched: number;
  notFound: number;
  invalidType: number;
  duplicateCode: number;
}

export interface PreviewResponse {
  status: 0 | 1;
  message?: string;
  summary?: PreviewSummary;
  entries?: PreviewEntry[];
}

export interface CommitResult {
  fileName: string;
  studentCode: string;
  status: CommitStatus;
  enquiryId: number | null;
  studentName: string | null;
  photoUrl: string | null;
  message: string | null;
}

export interface CommitSummary {
  total: number;
  uploaded: number;
  skipped: number;
  failed: number;
}

export interface CommitResponse {
  status: 0 | 1;
  message?: string;
  summary?: CommitSummary;
  results?: CommitResult[];
}

class StudentPhotoUploadService {
  async preview(file: File): Promise<PreviewResponse> {
    const formData = new FormData();
    formData.append("file", file);
    const resp = await myAxios.post<any>(`${BASE}/preview`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return resp.data as PreviewResponse;
  }

  async commit(file: File): Promise<CommitResponse> {
    const formData = new FormData();
    formData.append("file", file);
    const resp = await myAxios.post<any>(`${BASE}/commit`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return resp.data as CommitResponse;
  }
}

export default new StudentPhotoUploadService();
